import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PenProduct, Product } from '../../../shared/interfaces/product';
import { FormsModule } from '@angular/forms';
import { TermMileMonthPipe } from '../../pipes/term-mile-month.pipe';
import { Sale } from '../../../shared/interfaces/sale';
import { CalculatePaymentWithSalePipe } from '../../pipes/calculate-payment-with-sale.pipe';
import { PaymentSuffixPipe } from '../../../shared/pipes/payment-suffix.pipe';
import { IframeVideoPlayerComponent } from '../step-display-video/iframe-video-player/iframe-video-player.component';
import { MatDialog } from '@angular/material/dialog';
import { VideoDialogComponent } from '../../../shared/dialogs/video-dialog/video-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { IframeDialogComponent } from '../../../shared/dialogs/iframe-dialog/iframe-dialog.component';
import { ProductsService } from '../../../admin/services/products.service';
import { OverflowDetectDirective } from '../../directives/overflow-detect.directive';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-pen-product-card',
    standalone: true,
    imports: [CommonModule, FormsModule, TermMileMonthPipe, CalculatePaymentWithSalePipe, PaymentSuffixPipe, IframeVideoPlayerComponent, MatButtonModule, OverflowDetectDirective],
    templateUrl: './pen-product-card.component.html',
    styleUrl: './pen-product-card.component.scss',
})
export class PenProductCardComponent {
    @Input({ required: true }) public product!: PenProduct;

    @Output() public readonly remove = new EventEmitter<void>();

    @Input() public sale?: Sale;

    @Input() public selected?: boolean | null;

    @Input() public selectedProductId?: number | null;

    @Output() public readonly selectedProductIdChange = new EventEmitter<number>();

    public constructor(
        private readonly dialog: MatDialog,
        private readonly products: ProductsService,
    ) {
    }

    public get selectedProduct(): Product | null | undefined {
        return this.product.options.find(o => o.id === this.selectedProductId);
    }

    public openBrochure(): void {
        if (!this.product.brochure_url) {
            return;
        }

        this.dialog.open(IframeDialogComponent, {
            data: {
                uri: this.product.brochure_url,
            },
            width: '85vw',
            height: '85vh',
        });
    }

    public openProductDetails(): void {
        this.products.openPenProductDialog(this.product);
    }

    public openVideoModal(): void {
        if (!this.product.video_url) {
            return;
        }

        this.dialog.open(VideoDialogComponent, {
            data: {
                type: 'iframe',
                uri: this.product.video_url,
            },
            width: '80vw',
        });
    }
}
